import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { useStores } from 'presentation/hooks/use-stores'
import PatientHome from 'presentation/patient/pages/Home'
import React, { useEffect } from 'react'
import { ApiRepository } from 'repository/api-repository'
import { PatientRepository } from 'repository/repositories/patient/patient-repository'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { RemoteGetPatientNextAttendances } from 'service/usecases/get-patient-next-attendances/remote-get-patient-next-attendances'
import { RemoteLoadPatientInfo } from 'service/usecases/load-patient-info/remote-load-patient-info'
import { RemoteLoadPatientSurgery } from 'service/usecases/load-patient-surgery/remote-load-patient-surgery'
import { RemoteLoadSurgicalOrderStatus } from 'service/usecases/load-surgical-order-status/remote-load-surgical-order-status'

export default function makePatientHome() {
  const stores = useStores()
  const surgicalstatus = stores.surgicalstatus

  useEffect(() => {
    async function loadData() {
      await surgicalstatus.load()
    }
    loadData()
  }, [])
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const patientRepository = new PatientRepository(apiRepository)
  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)

  const loadPatientSurgery = new RemoteLoadPatientSurgery(patientRepository)
  const loadPatientInfo = new RemoteLoadPatientInfo(patientRepository)
  const loadSurgicalOrderStatus = new RemoteLoadSurgicalOrderStatus(
    surgicalOrderRepository
  )

  const getPatientNextAttendances = new RemoteGetPatientNextAttendances(
    patientRepository
  )

  return (
    <PatientHome
      loadPatientSurgery={loadPatientSurgery}
      loadPatientInfo={loadPatientInfo}
      loadSurgicalOrderStatus={loadSurgicalOrderStatus}
      getPatientNextAttendances={getPatientNextAttendances}
    />
  )
}
